export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_SERVER_URL,

  API_PREFIX: '/api/v1' as const,

  get FULL_API_URL() {
    return `${this.BASE_URL}${this.API_PREFIX}`;
  },

  TIMEOUTS: {
    CLIENT: 10000,
    FAST: 8000,
    SERVER: 15000,
  } as const,
} as const;

export const validateApiConfig = (): boolean => {
  const { BASE_URL } = API_CONFIG;

  if (!BASE_URL) {
    console.error(
      'API configuration error: VITE_API_SERVER_URL is not defined'
    );
    return false;
  }

  if (BASE_URL.includes('localhost') && import.meta.env.PROD) {
    console.error('Production environment should not use localhost URLs');
    return false;
  }

  try {
    new URL(BASE_URL);
  } catch (error) {
    console.error('Invalid BASE_URL format:', BASE_URL, error);
    return false;
  }

  return true;
};

export const getEnvironmentInfo = () => {
  return {
    baseUrl: API_CONFIG.BASE_URL,
    fullApiUrl: API_CONFIG.FULL_API_URL,
    mode: import.meta.env.MODE,
    isValid: validateApiConfig(),
    timestamp: new Date().toISOString(),
  };
};

export const debugApiConfig = () => {
  if (import.meta.env.DEV) {
    console.log('=== API Configuration Debug ===');
    console.log(getEnvironmentInfo());
    console.log('==============================');
  }
};

export type ApiConfig = typeof API_CONFIG;
export type EnvironmentInfo = ReturnType<typeof getEnvironmentInfo>;
